// src/components/common/JsonSchemaFormMUI.jsx
import React from "react";
import Form from "@rjsf/mui";
import validator from "@rjsf/validator-ajv8";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";

const uiSchema = {
  TipoParte: { "ui:widget": "hidden" },
  TipoParteDescripcion: { "ui:widget": "hidden" },
};

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#00bcd4" },
    background: { default: "#1d1f24", paper: "#24272e" },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": { color: "#aaa" },
          "& input": { color: "#fff" },
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#00bcd4" },
            "&:hover fieldset": { borderColor: "#40c4ff" },
            "&.Mui-focused fieldset": { borderColor: "#40c4ff" },
          },
        },
      },
    },
  },
});

export default function JsonSchemaFormMUI({ schema, formData, onChange }) {
  if (!schema || !schema.properties) {
    return <p style={{ color: "#999" }}>Schema no disponible</p>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ p: 1, backgroundColor: "#24272e", borderRadius: 2 }}>
        <Form
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          onChange={onChange}
          validator={validator}
          liveValidate
          noValidate
          showErrorList={false}
        >
          <></>
        </Form>
      </Box>
    </ThemeProvider>
  );
}
